import { render, staticRenderFns } from "./TutoriaDetalleObservaciones.vue?vue&type=template&id=4994019e&"
import script from "./TutoriaDetalleObservaciones.vue?vue&type=script&lang=js&"
export * from "./TutoriaDetalleObservaciones.vue?vue&type=script&lang=js&"
import style0 from "./TutoriaDetalleObservaciones.vue?vue&type=style&index=0&id=4994019e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports